export const capitaliseAllChars = (string: string) => {
    return string.toUpperCase()
}